(() => {
  function setup(root){
    if(root.dataset.ready || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal)return;
    root.querySelectorAll('[data-story-open]').forEach(link=>{
      const dialog=document.getElementById(link.dataset.storyOpen);if(!dialog||!dialog.showModal)return;
      let opener;
      link.addEventListener('click',event=>{event.preventDefault();opener=link;dialog.showModal();document.body.classList.add('os-story-modal-open');dialog.querySelector('[data-story-close]').focus();});
      dialog.querySelector('[data-story-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('keydown',event=>{
        if(event.key!=='Tab')return;
        const focusable=[...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')].filter(element=>element.getClientRects().length);
        const first=focusable[0],last=focusable[focusable.length-1];
        if(!first)return;
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
      });
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>{document.body.classList.remove('os-story-modal-open');opener?.focus({preventScroll:true});});
    });
    root.dataset.ready='true';
  }
  document.querySelectorAll('[data-os-story]').forEach(setup);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-os-story]').forEach(setup));
})();
